module.exports = __webpack_public_path__ + "img/cn_pocket-14.39ddef4.jpg";